import { useMemo } from 'preact/hooks'
import { useAthosContext } from 'libs/athos/fetchers/provider'

export function useMerchedResults() {
  const { results } = useAthosContext()

  const merchedResults = useMemo(() => {
    if (!results?.results) return []
    const items = [...results.results]

    results?.merchandising?.content?.inline?.forEach((content) => {
      const isBefore = content.config.position.index < results.pagination.begin
      const isAfter = content.config.position.index > results.pagination.end
      if (isBefore || isAfter) return

      // Get relative index to actual page
      const index = content.config.position.index - results.pagination.begin + 1
      items.splice(index, 0, content)
    })

    items.forEach((item) => (item.page = results?.pagination?.currentPage))

    return items
  }, [results])

  return merchedResults
}
